import * as React from 'react'
import { LogLevel } from '../../model'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './LogLevelOption.css'

export type Props = {
  logLevel: {value: LogLevel, label: string}
}

const LogLevelOption = (props: Props) => {
  const label = props.logLevel.label
  const value = props.logLevel.value
  const showWarning = value === LogLevel.TRACE || value === LogLevel.DEBUG

  return (
    <div className="log-level-option">
      <label>{label}</label>
      { showWarning &&
        <div className="log-level-warning">
          <label className="log-level-warning-text">Affects performance</label>
          <IconPanel
            className="log-level-warning-icon"
            data-test-id="log-level-warning-icon"
            name="warning-small"
            size={13}
            fill="#F2BE24"
          />
        </div>
      }
    </div>
  )
}

export default LogLevelOption
